import { ContactShadows, Environment, Lightformer, MeshReflectorMaterial, Plane, useTexture } from "@react-three/drei"
import { config } from "../config/config";
import { useMemo } from "react";

const floorCount = 10;

export const Room = () => {
  const floorTexture = useTexture('./textures/floor-tiles.jpg');
  const roughnessMap = useTexture('./textures/floor-roughness.jpg');


  return <>
    {/* Room floor */}

    <Plane args={[config.roomSize[0] * 10, config.roomSize[1] * 10]} rotation={[-Math.PI / 2, 0, 0]} position={[0, 0, 0]} receiveShadow>
      <MeshReflectorMaterial
        envMapIntensity={0}
        map={floorTexture}
        // normalMap={normal}
        // normalScale={[0.15, 0.15]}
        roughnessMap={roughnessMap}
        dithering={true}
        color={[20, 20, 20]}
        roughness={0.75}
        blur={[1000, 400]} // Blur ground reflections (width, heigt), 0 skips blur
        mixBlur={1} // How much blur mixes with surface roughness (default = 1)
        mixStrength={0.5} // Strength of the reflections
        mixContrast={0.5} // Contrast of the reflections
        resolution={1024} // Off-buffer resolution, lower=faster, higher=better quality, slower
        mirror={0.75} // Mirror environment, 0 = texture colors, 1 = pick up env colors
        depthScale={1} // Scale the depth factor (0 = no depth, default = 0)
        minDepthThreshold={0.9} // Lower edge for the depthTexture interpolation (default = 0)
        maxDepthThreshold={1} // Upper edge for the depthTexture interpolation (default = 0)
        depthToBlurRatioBias={0.75} // Adds a bias factor to the depthTexture before calculating the blur amount [blurFactor = blurTexture * (depthTexture + bias)]. It accepts values between 0 and 1, default is 0.25. An amount > 0 of bias makes sure that the blurTexture is not too sharp because of the multiplication with the depthTexture
        reflectorOffset={0} // Offsets the virtual camera that projects the reflection. Useful when the reflective surface is some distance from the object's origin (default = 0)
      />
    </Plane>

    {/* Room walls */}
    {/* <Plane args={[config.roomSize[0], config.roomSize[2]]} position={[0, config.roomSize[2] / 2, - config.roomSize[1] / 2]}   >
      <meshStandardMaterial attach="material" map={wallTexture} />
    </Plane>
    <Plane args={[config.roomSize[0], config.roomSize[2]]} rotation={[0, -Math.PI, 0]} position={[0, config.roomSize[2] / 2, config.roomSize[1] / 2]}  >
      <meshStandardMaterial attach="material" map={wallTexture} />
    </Plane>
    <Plane args={[config.roomSize[1], config.roomSize[2]]} rotation={[0, -Math.PI / 2, 0]} position={[config.roomSize[0] / 2, config.roomSize[2] / 2, 0]}  >
      <meshStandardMaterial attach="material" map={wallTexture} />
    </Plane>
    <Plane args={[config.roomSize[1], config.roomSize[2]]} rotation={[0, Math.PI / 2, 0]} position={[-config.roomSize[0] / 2, config.roomSize[2] / 2, 0]}  >
      <meshStandardMaterial attach="material" map={wallTexture} />
    </Plane> */}
    {/* Ceiling */}
    {/* <Plane args={[config.roomSize[0], config.roomSize[1]]} rotation={[Math.PI / 2, 0, 0]} position={[0, config.roomSize[2], 0]}  >
      <meshStandardMaterial attach="material" map={wallTexture} />
    </Plane> */}

    <ambientLight intensity={1} />
    <spotLight
      intensity={1}

    />
    <pointLight
      intensity={1}

    />
    <Environment preset='city'>
      <Lightformer
        form="rect" // circle | ring | rect (optional, default = rect)
        intensity={1} // power level (optional = 1)
        color="white" // (optional = white)
        scale={1} // Scale it any way you prefer (optional = [1, 1])
        target={[0, 0, 0]} // Target position (optional = undefined)
      />
    </Environment>
  </>
}